import * as GETTERS from '@/store/constants/getters.js';

export const getters = {
    [GETTERS.FOLLOW_DATA_BY_UUID](state) {
        return (uuid) => state[uuid];
    },
};
